import { firestore, firebase } from "./firebase";
const COMMENT_COLLECTION = "comments";
const COMMENT_SUB_COLLECTION = "comment";

export async function getArticleCommentsList(aid) {
  return await firestore
    .collection(COMMENT_COLLECTION)
    //.doc(aid)
    //.collection(COMMENT_SUB_COLLECTION)
    .where("aid", "==", aid)
    .get();
}

export async function getCommentData(aid, cid) {
  return await firestore
    .collection(COMMENT_COLLECTION)
    //.doc(aid)
    //.collection(COMMENT_SUB_COLLECTION)
    .doc(cid)
    .get();
}

export async function uploadNewComment(comment) {
  var ref = firestore
    .collection(COMMENT_COLLECTION)
    //.doc(aid)
    //.collection(COMMENT_SUB_COLLECTION)
    .doc();
  const batch = firestore.batch();
  //內文
  batch.set(ref, comment, { merge: true });
  //編輯時間:
  const timestamp = firebase.firestore.FieldValue.serverTimestamp();
  batch.update(ref, { updatedAt: timestamp });
  var com =await batch.commit();
  //return await batch.commit();
  return {com,ref};
}

export async function deleteComment(cid) {
  return await firestore.collection(COMMENT_COLLECTION).doc(cid).delete();
}
